import React, { useState } from 'react';

import { FilterIcon } from '../../../icons'

import {
    Box,
    Drawer,
    Button,
    Typography,
    IconButton,
    useMediaQuery,
    useTheme,
    InputLabel,
    Avatar,
    Tooltip,
    FormControlLabel,
    Switch,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import FilterListIcon from '@mui/icons-material/FilterList';

import { FilterwIcon} from '../../../icons';


import SingleSelectDroupdown from '../../../components/Projects/project-components/SingleSelectDroupdown';
import TeamSelectDroupDown from '../../../components/Projects/project-components/TeamSelectDroupDown';

import ActivityLevel from '../../../components/DemoTabs/ActivityLevel';


const AmountsFilter = () => {
    const [billable, setBillable] = useState(true);
    const [disableActivity, setDisableActivity] = useState(false);

    // Project Seclect Single 
    const [selectedProject, setSelectedProject] = useState(null);
    // Project Seclect Single 



    // Project Seclect Single 
    const [selectedTeamsAll, setSelectedTeamsAll] = useState(null);
    // Project Seclect Single 



    // start Rate level 
    const [selectedRate, setSelectedRate] = useState('');

    const RateData = [
        { name: '<=$10', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: '$11 - $ 20', image: null },
        { name: '$21- $ 30', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: '$31 - $ 40', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: '$41 - $ 50', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: '$51 - $ 60', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
    ];
    // End Rate level 


    // start activity level 
    const [selectedActivityLevel, setSelectedActivityLevel] = useState('');

    const ActivityLevelData = [
        { name: '95 %', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: '90 %', image: null },
        { name: '85 %', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: '80 %', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: '75 %', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: '70 %', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: '60 %', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
    ];
    // End activity level 

    // export default function FilterPopup() {
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const DrawerContent = (
        <Box sx={{ width: isMobile ? '100vw' : 360, height: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#fff', borderRadius: isMobile ? 0 : '0 0 0 0' }} role="presentation">
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center"
                sx={{ p: '24px', borderBottom: '1px solid #D0D4E4', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
                <Typography fontSize={'22px'} fontWeight={700} sx={{ fontFamily: 'Manrope' }}>Filter</Typography>
                <IconButton onClick={toggleDrawer(false)} sx={{ p: 0 }}>
                    <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                </IconButton>
                <Box onClick={toggleDrawer(false)}
                    style={{
                        position: 'absolute', backgroundColor: '#fff', borderRadius: '100px', boxShadow: '0px 1px 6px 2px #00000030', height: '32px',
                        width: '32px', display: 'flex', justifyContent: 'center', alignItems: 'center', left: '-12px', bottom: '-16px', cursor: 'pointer',
                        zIndex: 10,
                    }}>
                    <ChevronRightIcon fontSize="small" />
                </Box>
            </Box>

            {/* Body */}
            <Box sx={{ flex: 1, overflowY: 'auto', px: 3, py: 3 }}>
                {/* start Projects sec  */}
                <Box sx={{ pb: 0, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Projects</InputLabel>
                    <SingleSelectDroupdown
                        selectedProject={selectedProject}
                        setSelectedProject={setSelectedProject}
                    />


                </Box>
                {/* End Projects sec  */}

                {/* start Teams sec  */}
                <Box sx={{ pb: 0, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Teams</InputLabel>
                    <TeamSelectDroupDown
                        selectedTeamsAll={selectedTeamsAll}
                        setSelectedTeamsAll={setSelectedTeamsAll}
                    />
                </Box>
                {/* End Teams sec  */}

                {/* start Activity Level */}
                <Box sx={{ pb: 2, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Rate</InputLabel>
                    <ActivityLevel label="All Rate" options={RateData} selectedValue={selectedRate} onChange={setSelectedRate} />
                </Box>

                {/* End Activity Level */}


                {/* start Activity Level */}
                <Box sx={{ pb: 2, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Activity Level</InputLabel>
                    <ActivityLevel label="All levels" options={ActivityLevelData} selectedValue={selectedActivityLevel} onChange={setSelectedActivityLevel} />
                </Box>

                {/* End Activity Level */}





                <Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ margin: '0px auto 16px' }}>
                        <Typography className="" fontWeight={'600'} sx={{ fontSize: '14px', color: '#1A1F36', fontFamily: 'Manrope' }}>Sum date ranges</Typography>
                        <FormControlLabel control={
                            <Switch
                                checked={billable}
                                onChange={() => setBillable(!billable)}
                                color="primary"
                                sx={{
                                    width: 40,
                                    height: 25,
                                    padding: 0,
                                    '& .MuiSwitch-switchBase': {
                                        padding: 0.5,
                                        '&.Mui-checked': {
                                            transform: 'translateX(16px)',
                                            color: '#fff',
                                            '& + .MuiSwitch-track': {
                                                backgroundColor: '#E0EEFE',
                                                opacity: 1,
                                                border: '1px solid #0076FE1F',

                                            },
                                            '& .MuiSwitch-thumb': {
                                                backgroundColor: '#0076FE',
                                            }
                                        },
                                    },
                                    '& .MuiSwitch-thumb': {
                                        width: 13,
                                        height: 13,
                                        boxShadow: ' 0 1px 1px #00000040',
                                        margin: '2px auto 0',
                                    },
                                    '& .MuiSwitch-track': {
                                        borderRadius: '20px',
                                        backgroundColor: '#E5E8EB',
                                        opacity: 1,
                                        border: '1px solid #D0D5DD',
                                    },
                                }}
                            />
                        }
                        />
                    </Box>
                </Box>

            </Box>

            {/* Footer */}
            <Box
                sx={{
                    p: isMobile ? 2 : '24px 30px',
                    borderTop: '1px solid #DFDFDF',
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: 2,
                    justifyContent: 'center',
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 1
                }}
            >
                <Button onClick={toggleDrawer(false)} variant="outlined" fullWidth={isMobile}
                    sx={{ backgroundColor: '#fff', textTransform: 'capitalize', color: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: 500, height: '50px', border: '1px solid #9095A1', borderRadius: '8px', fontFamily: 'Manrope' }}>
                    Clear Filters
                </Button>
            </Box>
        </Box>
    );

    return (
        <>
            {/* <Tooltip title="Filter" arrow placement='top'>
                <Button onClick={toggleDrawer(true)} sx={{
                    background: '#fff',
                    borderRadius: '50px',
                    color: '#1A1F36',
                    fontSize: '16px',
                    textTransform: 'capitalize',
                    width: '40px',
                    height: '38px',
                    border: '1px solid #E5E8EB',
                    '&:hover': {
                        background: '#f5f5f5'
                    }
                }}><FilterIcon /></Button>
            </Tooltip> */}

            <Button onClick={toggleDrawer(true)} component="label" variant="contained" sx={{ borderRadius: '50px', fontSize: '14px', background: '#0076FE', border: '1px solid #0076FE', color: '#fff', boxShadow: 'none',}}
                        tabIndex={-1} startIcon={<FilterwIcon />}>
                        Filter
                      </Button>
            <div>
                <Drawer
                    anchor="right"
                    open={open}
                    onClose={toggleDrawer(false)}
                    PaperProps={{
                        sx: {
                            width: isMobile ? '100vw' : 360,
                            borderRadius: isMobile ? 0 : '0 0 0 0',
                            overflow: 'visible',
                        }
                    }}
                >
                    {DrawerContent}
                </Drawer>
            </div>

        </>



    );
}

export default AmountsFilter;
